import { render, staticRenderFns } from "./merchant-input.vue?vue&type=template&id=12189e62&scoped=true&"
import script from "./merchant-input.vue?vue&type=script&lang=js&"
export * from "./merchant-input.vue?vue&type=script&lang=js&"
import style0 from "./merchant-input.vue?vue&type=style&index=0&id=12189e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12189e62",
  null
  
)

export default component.exports